import {createReducer, on} from '@ngrx/store';
import * as ProcessInfoActions from './process-info.actions';
import {ProcessInfoDTO} from '../dto/process-info';

export interface ProcessInfoState {
  messagesByProject: { [projectId: number]: string };
  lastMessage: string | null;
  lastChatSources: string | null;
  showMessage: boolean;
  showLoading: boolean;
  errorMessages: string[];
  streamStarted: boolean;
  lastProcessInfo?: ProcessInfoDTO;
}

export const initialState: ProcessInfoState = {
  messagesByProject: {},
  showMessage: false,
  showLoading: false,
  errorMessages: [],
  lastMessage: null,
  lastChatSources: null,
  streamStarted: false,
};

export const processInfoReducer = createReducer(
  initialState,
  on(ProcessInfoActions.receiveProcessInfoMessage, (state, {message}) => ({
    ...state,
    messagesByProject: {
      ...state.messagesByProject,
      [message.projectId]: message.message,
    },
    errorMessages: message.error
      ? [...state.errorMessages, message.message]
      : state.errorMessages,
    lastMessage: message.error ? state.lastMessage : message.message,
    showMessage: true,
    lastProcessInfo: message
  })),
  on(ProcessInfoActions.removeInfoErrorMessage, (state, {index}) => ({
    ...state,
    errorMessages: state.errorMessages.filter((_, i) => i !== index),
  })),
  on(ProcessInfoActions.removeAllInfoErrorMessage, (state) => ({
    ...state,
    errorMessages: [],
  })),
  on(ProcessInfoActions.stopSseStreamInfo, (state) => ({
    ...state,
    lastProcessInfo: state.lastProcessInfo ? {
      ...state.lastProcessInfo,
      processFinished: true
    } : undefined,
  })),
  on(ProcessInfoActions.startLoadingProcessInfoSseStream, (state, {}) => ({
    ...state,
    showLoading: true,
  })),
  on(ProcessInfoActions.stopLoadingProcessInfoSseStream, (state, {}) => ({
    ...state,
    showLoading: false,
  })),
  on(ProcessInfoActions.showLoadingProcessInfoSseStream, (state, {}) => ({
    ...state,
    showMessage: true,
  })),
  on(ProcessInfoActions.hideLoadingProcessInfoSseStream, (state, {}) => ({
    ...state,
    showMessage: false,
    lastProcessInfo: undefined
  })),
  on(ProcessInfoActions.startProcessInfoSseStream, (state, {}) => ({
    ...state,
    error: null,
    streamStarted: true,
  })),
  on(ProcessInfoActions.processInfoStreamError, (state, {error}) => ({
    ...state,
    error: error,
    streamStarted: false,
  })),
  on(ProcessInfoActions.sseStreamCompleted, (state, {}) => ({
    ...state,
    streamStarted: false,
  })),
  on(ProcessInfoActions.receiveChatSourcesMessage, (state, {message}) => ({
    ...state,
    lastChatSources: message.message,
  })),
  on(ProcessInfoActions.clearChatSourcesMessage, (state, {}) => ({
    ...state,
    lastChatSources: null,
  })),
);
